// Приложение выборщика.

import {h, render} from 'preact';
// import 'preact/devtools';
import Root from './Root';
import {getState, subscribe} from './Store/index';
import applyQueryString from './utils/applyQueryString';
import getUtmParameters from './utils/getUtmParameters';
import removeUtmParameters from './utils/removeUtmParameters';
import {setUtmParameters} from './utils/updateAddress';

/**
 * Приложение выборщика.
 */
async function main(): Promise<void>
{
	const main = document.querySelector( 'main' ) as HTMLElement;
	
	if (
		!main
		|| !main.parentElement
	)
	{
		return;
	}
	
	let oldLoading: boolean = false;
	let firstListLoading: boolean = true;
	
	subscribe(
		() =>
		{
			const state = getState();
			
			if (
				firstListLoading
				&& ( state.listData.items.length !== 0 )
			)
			{
				firstListLoading = false;
				
				const itemIds: number[] = [];
				
				for ( let i = 0; i < 3; i++ )
				{
					const item = state.listData.items[i];
					
					if ( !item )
					{
						break;
					}
					
					itemIds.push( item.id );
				}
				
				const criteoTrackers: any[] = (window as any).criteo_q || [];
				
				if ( criteoTrackers )
				{
					criteoTrackers.push(
						{
							event: 'setAccount',
							account: 42843,
						},
						{
							event: 'setEmail',
							email: '',
						},
						{
							event: 'setSiteType',
							type: (
								/iPad/.test( navigator.userAgent )
								? 't'
								: (
									/webOS|Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/
										.test( navigator.userAgent )
									? 'm'
									: 'd'
								)
							),
						},
						{
							event: 'viewList',
							item: itemIds,
						},
					);
				}
			}
			
			const loading = state.common.loading;
			
			if ( loading === oldLoading )
			{
				return;
			}
			
			oldLoading = loading;
			
			if ( loading )
			{
				document.body.classList.add( 'loading' );
			}
			else
			{
				document.body.classList.remove( 'loading' );
			}
		},
	);
	
	setUtmParameters( getUtmParameters().join( '&' ) );
	await applyQueryString( removeUtmParameters( window.location.search ) );
	render( <Root />, main.parentElement, main );
}

/**
 * Module
 */
export {
	main as default,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/index.tsx